export enum CustomerStatus {
	active = 'active',
	inactive = 'inactive',
}
